import React from "react";
import { Map, InfoWindow, Marker, GoogleApiWrapper } from "google-maps-react";
import mediaQuery from "../../common/mediaQuery";

const GoogleMaps = (props) => {
  const { small } = mediaQuery();

  const style = {
    width: small ? "80vw" : "25vw",
    height: small ? "35vh" : "30vh",
    borderColor: "#22222240",
    borderRadius: 10
  };

  const { lat, lon, place } = props;

  return (
    <Map
      google={props.google}
      zoom={17}
      initialCenter={{
        lat: lat,
        lng: lon
      }}
      style={style}
    >
      <Marker onClick={props.onMarkerClick} name={place} />

      <InfoWindow onClose={props.onInfoWindowClose} />
    </Map>
  );
};

export default GoogleApiWrapper({
  apiKey: "AIzaSyB--mNPe0vvVocVj5siEwClfgocXxFgBe4"
})(GoogleMaps);
